import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import { Sucursal } from './sucursal';

import myGlobals = require('../config');

@Injectable()
export class SucursalService {

  private sucursalUrl = myGlobals.default.BASE_URL+'/sucursal/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todas las sucursales
  getSucursales() {
    return this.http.get(this.sucursalUrl)
               .map((response) => response.json());
  }

  //Obtener una sucursal
  getSucursal(_id: string): Observable<Sucursal>  {
    return this.http.get(this.sucursalUrl+_id)
               .map((response) => response.json());
  }

  //Obtener sucursales by empresa
  getSucursalByEmpresa(_id: string) {
    return this.http.get(this.sucursalUrl+"empresa/"+_id)
               .map((response) => response.json());
  }

  //Obtener sucursales by empresa
  getPresupuestoCalibracion(_id: number) {
    return this.http.get(this.sucursalUrl+"presupuestoCalibracion/"+_id)
        .map((response) => response.json());
  }

  save(sucursal: Sucursal): Observable<Sucursal>  {
    if (sucursal._id) {
      return this.put(sucursal);
    }
    //Seteo estado activo
    sucursal.estado=true;
    return this.post(sucursal);
  }

  //Desactivar sucursal
  delete(sucursal: Sucursal) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.sucursalUrl}/${sucursal._id}`;

    return this.http
               .delete(url, {headers: headers})
               .map((response) => response.json());
  }

  // Agregar nueva sucursal
  private post(sucursal: Sucursal):Observable<Sucursal> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'});
    headers.append('dataType', 'json');
    console.log(JSON.stringify(sucursal));
    var sucursalStr=JSON.stringify(sucursal);
    return this.http
               .post(this.sucursalUrl, sucursalStr, {headers: headers})
                .map((response) => response.json());
  }

  // Actualizar sucursal
  private put(sucursal: Sucursal) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.sucursalUrl}/${sucursal._id}`;

    return this.http
               .put(url, JSON.stringify(sucursal), {headers: headers})
               .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/sucursal/sucursal.service.ts